import $ from 'jquery'

export default {
	name: 'assure-analyses',
	components: {},
	props: {
		list_exclu_analyses: Array
	},
	data() {
		return {
			is_empty: false,
			is_loading: true,
			checked_exclusions: [],

			u_loading: false,
			btn_disable: false,

			select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
		}
	},

	watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_ANALYSE', this.one_is_checked)
        }
    },

	computed: {
		/**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

		categoriesAnalyses() {
            return this.$store.getters["categoriesAnalyses"];
        },

		params_analyses() {
            return this.$store.getters["params_analyses"];
        },
	},
	mounted() {
		this.one_is_checked = []
		this.each_cat_is_checked = []

		this.user_id = this.userCredentials.id

		this.listTypeAnalyses()
	},
	methods: {
		listTypeAnalyses() {
			this.$store.dispatch("getCategoriesAnalyses").then(() => {
				if (this.categoriesAnalyses.length > 0) {
					if (this.list_exclu_analyses != undefined && this.list_exclu_analyses.length > 0) {
						this.setSelectedTypeAnalyses()
					}
				}
			}).then(() => { this.$store.commit('SET_EXCLU_ANALYSE', this.one_is_checked); this.$emit('pret') }).catch(() => { this.$emit('erreur') })
		},

		setSelectedTypeAnalyses() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_analyses.forEach(exclusion => {
                this.categoriesAnalyses.forEach(categorie_analyse => {
					categorie_analyse.analyses.forEach((analyse) => {
						if (exclusion.id == analyse.id) {
							this.text_grey[analyse.id] = 'text-grey'
							this.one_is_checked.push(analyse.id)
						}
					}) 
                });
            });
		},

		/**
		 * Sélectionner / Déselectionner toutes les catégories d'analyses
		 * ainsi que toutes les analyse
		 */
		toutSelectionner() {
            let is_checked = $('#analyse-tous').is(":checked")

			this.toggleAllChecked(is_checked)
        },

		toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.categoriesAnalyses.forEach((categorie_analyse) => {
                if (is_checked) {
                    this.each_cat_is_checked.push(categorie_analyse.id)
                }

                categorie_analyse.analyses.forEach((analyse) => {
                    this.text_grey[analyse.id] = (is_checked)?'text-grey':''

                    if (is_checked) {
                        this.one_is_checked.push(analyse.id)
                    }
                })
            });
            
            this.all_checked = is_checked
        },

		/**
		 * Sélectionner / Déselectionner une catégorie d'analyse
		 */
		touteCategorie(index) {
			let is_checked = $('#cat-tous'+index).is(":checked")
			this.toggleCategorieChecked(is_checked, index)
		},

		toggleCategorieChecked(is_checked, index) {
            this.categoriesAnalyses.forEach((categorie_analyse) => {
                if (categorie_analyse.id == index) {
                    categorie_analyse.analyses.forEach((analyse) => {
                        this.text_grey[analyse.id] = (is_checked)?'text-grey':''

                        if (is_checked) {
                            this.one_is_checked.push(analyse.id)
                        } else {
                            let index_of = this.one_is_checked.indexOf(analyse.id)
                            if (index_of > -1) {
                                this.one_is_checked.splice(index_of, 1)
                            }
                        }
                    })
                }
            });
            
            this.all_checked = is_checked
        },

        onExclu(index, cat_index) {
			console.log(index, cat_index);
            let is_checked = $('#alys'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        }, 
	}
}


